import http from '../http'

// 新闻状态：0 草稿 / 1 已发布 / 2 下架
const STATUS_PUBLISHED = 1

export default {
  // 分页查询新闻列表（前台只取已发布）
  getNewsList: (params = {}) => {
    const { pageNum = 1, pageSize = 10, ...rest } = params
    return http.get('/api/api/news/page', {
      params: { pageNum, pageSize, status: STATUS_PUBLISHED, ...rest }
    })
  },
  // 查询新闻详情
  getNewsDetail: (id) => http.get(`/api/api/news/get/${id}`)
}
